import { useSettings } from "../contexts/SettingsContext";

export const useLinkProps = () => {
    const { settings } = useSettings();

    return () => (settings.newWindow ? { target: "_blank", rel: "noopener noreferrer" } : {});
};
